export default __webpack_public_path__ + "static/media/strategyChi0.5cbdb9d8.jpg";